import React from "react";

const SubmitButton = ({
  onClick,
  className,
  style,
  isSubmitting,
  children,
  type = "button",
}) => {
  return (
    <div>
      <button
        type={type}
        onClick={onClick}
        className={`btn btn-solid mt-2 ${className}`}
        style={style}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Loading" : children}
      </button>
    </div>
  );
};

export default SubmitButton;
